import type { JSX } from 'preact';
import type { CharacterConfig } from '../types/content';

interface CharacterStandeeProps {
  characterId: CharacterConfig['id'];
  accent?: string;
  compact?: boolean;
}

export function CharacterStandee({ characterId, accent = '#a9ff3f', compact = false }: CharacterStandeeProps) {
  return (
    <div
      class={`character-standee character-standee--${characterId}${compact ? ' character-standee--compact' : ''}`}
      style={{ '--standee-accent': accent } as JSX.CSSProperties}
      role="img"
      aria-label={`${characterId} standing pose`}
    >
      <i class="character-standee__burst" />
      <i class="character-standee__sprite" />
      <i class="character-standee__base" />
    </div>
  );
}
